import React from 'react';
import WebTab from './_code-web';
import { PageHero, PageWithSubNav, PlatformTabs } from '../../../components';
import pageHeroData from '../../../data/pages/components.yml';

const IndexPage = () => {
  return (
    <PageWithSubNav
      pageType="code"
      title="Tooltip"
      designCode
      subnav="components">
      <PageHero heroData={pageHeroData} tierTwo="Tooltip" />

      <PlatformTabs platforms={{ web: <WebTab /> }} />
    </PageWithSubNav>
  );
};

export default IndexPage;
